import { Default } from './customForm.default'
import { TCustomFormProps } from './types'

const CustomForm = <T extends Object>(props: TCustomFormProps<T>) => (
  <Default<T> {...props} />
)

CustomForm.Default = Default

export default CustomForm
